import { BaseFetch } from "../main-model"
export default class SubjectModel extends BaseFetch {
  getSubjectBy = (data) =>
    this.authFetch({
      url: "subject/getSubjectBy",
      method: "POST",
      body: JSON.stringify(data),
    })
  getSubjectById = (data) =>
    this.authFetch({
      url: "subject/getSubjectById",
      method: "POST",
      body: JSON.stringify(data),
    })
    updateSubjectById = (data) =>
    this.authFetch({
      url: "subject/updateSubjectById",
      method: "POST",
      body: JSON.stringify(data),
    }) 
    insertSubject = (data) =>
    this.authFetch({
      url: "subject/insertSubject",
      method: "POST",
      body: JSON.stringify(data),
    })
    insertRefSubject = (data) =>
    this.authFetch({
      url: "subject/insertRefSubject",
      method: "POST",
      body: JSON.stringify(data),
    })
    insertUploadSubject = (data) =>
    this.authFetch({
      url: "subject/insertUploadSubject",
      method: "POST",
      body: JSON.stringify(data),
    })
    deleteSubjectById = (data) =>
    this.authFetch({
      url: "subject/deleteSubjectById",
      method: "POST",
      body: JSON.stringify(data),
    })
}
